import { useEffect, useState } from "react";
import api from "@/lib/api";

const P_ORDER = ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn","Rahu","Ketu"];

const GUNA_COLOR = { Sattva: "#E5C158", Rajas: "#C15C3D", Tamas: "#6E6B64" };
const TATVA_COLOR = {
  "Fire": "#C15C3D", "Water": "#7B9BB8", "Earth": "#A8896C",
  "Air": "#A19E95", "Ether (Akasha)": "#8B5E7A",
};

export default function AttributesPanel({ profileId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try { setData(await api.attributes(profileId)); }
      catch (err) { console.error("attributes failed:", err); }
    })();
  }, [profileId]);

  if (!data) return <div className="text-[#A19E95] font-mono text-sm">Loading attributes…</div>;

  return (
    <div className="space-y-6" data-testid="attributes-panel">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border border-[#2A2D35] bg-[#181A1F] p-4">
          <div className="text-xs uppercase tracking-widest text-[#D4AF37] font-mono mb-3">Guna Balance</div>
          <div className="space-y-2">
            {Object.entries(data.guna_balance).map(([g, v]) => (
              <div key={g} className="flex items-center gap-3">
                <span className="w-20 text-sm text-[#E6E1D6]">{g}</span>
                <div className="flex-1 h-2 bg-[#0F1115] rounded-sm overflow-hidden">
                  <div className="h-full transition-all duration-500"
                       style={{ width: `${v}%`, backgroundColor: GUNA_COLOR[g] }} />
                </div>
                <span className="w-14 text-right font-mono text-xs text-[#A19E95]">{v}%</span>
              </div>
            ))}
          </div>
        </div>
        <div className="border border-[#2A2D35] bg-[#181A1F] p-4">
          <div className="text-xs uppercase tracking-widest text-[#D4AF37] font-mono mb-3">Elemental (Tatva) Balance</div>
          <div className="space-y-2">
            {Object.entries(data.elemental_balance).map(([t, v]) => (
              <div key={t} className="flex items-center gap-3">
                <span className="w-32 text-sm text-[#E6E1D6]">{t}</span>
                <div className="flex-1 h-2 bg-[#0F1115] rounded-sm overflow-hidden">
                  <div className="h-full transition-all duration-500"
                       style={{ width: `${v}%`, backgroundColor: TATVA_COLOR[t] }} />
                </div>
                <span className="w-14 text-right font-mono text-xs text-[#A19E95]">{v}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border border-[#2A2D35] overflow-x-auto">
        <table className="w-full font-mono text-xs">
          <thead className="bg-[#0F1115] text-[#6E6B64]">
            <tr>
              {["Planet","Guna","Tatva","Linga","Varna","Dhatu","Direction","Colour","State","Intensity"].map(h => (
                <th key={h} className="px-3 py-2 text-left">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {P_ORDER.map(p => {
              const row = data.table[p];
              return (
                <tr key={p} className="border-t border-[#2A2D35]" data-testid={`attr-${p}`}>
                  <td className="px-3 py-2 text-[#D4AF37] font-heading text-sm">{p}</td>
                  <td className="px-3" style={{ color: GUNA_COLOR[row.guna] }}>{row.guna}</td>
                  <td className="px-3" style={{ color: TATVA_COLOR[row.tatva] }}>{row.tatva}</td>
                  <td className="px-3 text-[#E6E1D6]">{row.linga}</td>
                  <td className="px-3 text-[#E6E1D6]">{row.varna}</td>
                  <td className="px-3 text-[#A19E95]">{row.dhatu}</td>
                  <td className="px-3 text-[#A19E95]">{row.direction}</td>
                  <td className="px-3 text-[#A8896C]">{row.colour}</td>
                  <td className="px-3" style={{
                    color: row.state === "Strong" ? "#7B906F" : row.state === "Weak" ? "#C15C3D" : "#A8896C"
                  }}>{row.state}</td>
                  <td className="px-3 text-[#E6E1D6]">
                    <div className="flex items-center gap-2">
                      <div className="w-16 h-1.5 bg-[#0F1115] rounded-sm overflow-hidden">
                        <div className="h-full bg-[#D4AF37]" style={{ width: `${row.intensity}%` }} />
                      </div>
                      <span>{row.intensity}</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
